import { useEffect, useRef } from "react"
import { useAnalytics } from "connected-components/analytics"
import { DASHBOARD_EVENTS } from "../events"

export function useModelChangeTracking(modelId: string | null) {
  const analytics = useAnalytics()
  const previousModelId = useRef<string | null>(null)

  useEffect(() => {
    if (modelId && previousModelId.current && modelId !== previousModelId.current) {
      analytics.track(DASHBOARD_EVENTS.MODEL_CHANGED, {
        oldModelId: previousModelId.current,
        newModelId: modelId,
      })
    }
    previousModelId.current = modelId
  }, [analytics, modelId])
}
